exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".RidePrice_root_3WHeR {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  padding: 12px 16px;\n  z-index: 1;\n  pointer-events: none;\n  animation-name: RidePrice_fadeIn_2DAnV;\n  animation-iteration-count: 1;\n  animation-timing-function: ease;\n  animation-duration: 500ms;\n}\n\n.RidePrice_wrapper_3cmrk {\n  max-width: 400px;\n  margin: 0 auto;\n  text-align: right;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n@media (min-width: 756px) {\n  .RidePrice_wrapper_3cmrk {\n    max-width: initial;\n    padding-left: 48px;\n    text-align: left;\n  }\n}\n\n.RidePrice_content_3YtKQ {\n  padding: 8px 16px;\n  pointer-events: initial;\n  animation-name: RidePrice_flash_yiXtz;\n  animation-iteration-count: 1;\n  animation-timing-function: ease;\n  animation-duration: 500ms;\n}\n\n@keyframes RidePrice_flash_yiXtz {\n  0% {\n    background-color: inherit;\n  }\n  25% {\n    background-color: rgba(33, 150, 243, .5);\n  }\n  100% {\n    background-color: inherit;\n  }\n}\n\n@keyframes RidePrice_fadeIn_2DAnV {\n  0% {\n    opacity: 0;\n  }\n  80% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"root": "RidePrice_root_3WHeR",
	"fadeIn": "RidePrice_fadeIn_2DAnV",
	"wrapper": "RidePrice_wrapper_3cmrk",
	"content": "RidePrice_content_3YtKQ",
	"flash": "RidePrice_flash_yiXtz"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader!./src/ondemand/components/RidePrice/RidePrice.css
// module id = 1250
// module chunks = 2